import type { IconSvgObject } from './types';

const MasterCardIcon: IconSvgObject = [
  ["path", { d: "M22 6V18C22 19.1046 21.1046 20 20 20H4C2.89543 20 2 19.1046 2 18V6C2 4.89543 2.89543 4 4 4H20C21.1046 4 22 4.89543 22 6Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M13.0002 12C13.0002 13.6569 11.6571 15 10.0002 15C8.34339 15 7.00025 13.6569 7.00025 12C7.00025 10.3431 8.34339 9 10.0002 9C11.6571 9 13.0002 10.3431 13.0002 12Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M12 9.76389C12.5308 9.28885 13.2316 9 14 9C15.6569 9 17 10.3431 17 12C17 13.6569 15.6569 15 14 15C13.2316 15 12.5308 14.7111 12 14.2361", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default MasterCardIcon;
